import { useEffect, useState } from "react";
import LeftMenu from "../components/LeftMenu";
import ProductItem from "../components/ProductItem";
import APIService from "../services/APIService";
import { useParams, useSearchParams } from "react-router-dom";
import { Empty, Pagination } from "antd";
import { queryParams } from "../utils";

export default function CategoryPage() {
  const [infoCategory, setInfoCategory] = useState([]);
  const [drugCategory, setDrugCategory] = useState([]);
  const [totalPage, setTotalPage] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const cateId = searchParams.get("cateId");
  const [page, setPage] = useState(1);
  const pageSize = 4;
  async function getInfoCategory(id) {
    const RESULT = await APIService.getInfoCategory(id);
    if (RESULT) {
      setInfoCategory(RESULT);
    }
  }
  async function getDrugCategory(category_id) {
    const RESULT = await APIService.getDrugList(
      undefined,
      undefined,
      category_id,
      page,
      8
    );
    if (RESULT) {
      setDrugCategory(RESULT.data);
      setTotalPage(RESULT.total);
    }
    setLoading(false);
  }

  useEffect(() => {
    setLoading(true);
    getDrugCategory(cateId, page);
    getInfoCategory(cateId);
  }, [cateId, page]);

  const onChange = (page) => {
    setPage(page);
    console.log(page);
  };
  console.log(drugCategory);
  return (
    <div className="flex sm:flex-row flex-col">
      <LeftMenu
        onChange={(id) => {
          let params = queryParams({
            cateId: id,
          });
          setSearchParams(params);
        }}
      ></LeftMenu>

      <div className="flex flex-col flex-1 sm:ml-6 mt-4 sm:mt-0">
        <div>
          {infoCategory.image_banner ? (
            <img
              className="h-[410px] sm:block hidden w-full mb-[21px] object-cover rounded-xl	"
              src={infoCategory.image_banner}
              alt=""
            />
          ) : null}

          <h2 className="font-bold text-[#222222] sm:text-xl text-base	 not-italic capitalize">
            {infoCategory.name}
          </h2>
        </div>
        {loading ? (
          <div className="w-full flex justify-center my-10">
            <div class="dots-indicators"></div>
          </div>
        ) : (
          <>
            <div className="grid lg:grid-cols-4 md:grid-cols-3 grid-cols-2 sm:gap-6 gap-2 mt-4">
              {drugCategory.map((item) => (
                <ProductItem product={item} />
              ))}
            </div>
            <div className="h-6"></div>
            {drugCategory.length > 0 ? (
              <Pagination
                pageSize={8}
                current={page}
                onChange={onChange}
                total={totalPage}
                showSizeChanger={false}
              />
            ) : (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                imageStyle={{
                  height: 35,
                }}
                description={<span>Không tìm thấy sản phẩm nào.</span>}
              ></Empty>
            )}
          </>
        )}
      </div>
    </div>
  );
}
